import { reactive } from 'vue'
/** @typedef {import('@/types/terminal-system').TerminalSystem} TerminalSystem */
/** @typedef {import('@/types/nav-menu').NavMenu} NavMenu */
export const storeTerminalSystems = reactive({
    /** @type TerminalSystem[]} */
    data: [],
    /** @type NavMenu */
    nav: { icon: "", text: "" },
});